import i18next from 'i18next';
import PriceComponent from './widgets/PriceComponent';
import CptCodeComponent from './widgets/CptCodeComponent';
import { SORTING_TYPES } from '../../../../../../../Shared/Table/helpers';
import FILTER_TYPES from '../../../../../../../Shared/Table/widgets/Filters/constants';

export const GET_CPTS_COLUMNS = (args = {}) => [
  {
    size: 230,
    header: i18next.t('tables:cptCode'),
    accessorKey: 'cptCode',
    disableSorting: true,
    Edit: (props) => <CptCodeComponent {...props} {...args} columnData={{
      isFilterable: true,
      options: args.cptCodes,
      filterType: FILTER_TYPES.SELECT,
      hasSearch: true,
    }} />,
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: args.cptCodes,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:price'),
    accessorKey: 'price',
    disableSorting: true,
    Edit: (props) => <PriceComponent {...props} {...args} />,
    filter: {},
  },
];

export const sortOptions = {
  price: {
    type: SORTING_TYPES.number,
  },
  cptCode: {
    type: SORTING_TYPES.string,
  },
};
